export default {
    title: "Home",
    addOrder: {
        title: "Register order",
        date_time: "Date and Time",
        order_value: "Order value",
        client_phone: "Client phone",
        success_message: "Order registered successfully",
        new_client_message: "New client in the database, request registration!",
        not_registered_message: "The Client has not registered yet",
        anonymous_title: "Anonymous order",
        anonymous_body:
            "You are generating an order without informing the client. <br /><br />This reduces the effectiveness and accuracy of reports, always remember to ask the client for their phone number.",
        suspect_value_title: "Suspicious value alert! ({0})",
        suspect_value_body:
            'You are generating an order with a value of <span style="display: inline-block">{0}</span> which is well above normal. <br /><br />Click confirm if this is not an error.',
        register_button: "Register Order",
        save_button: "Save",
        value_error: "Please check the order value",
        generic_success: "Order saved successfully",
        personalized_success: "Thanks {0}, you already have {1} points!",
        welcome_points: "Welcome, you already have {0} points!",
        thanks_points: "Thanks, you already have {0} points!",
    },
    searchClient: {
        title: "Search client",
        confirm_reward_title: "Confirm reward redemption",
        confirm_reward_body:
            'Redeem the reward "{0}" for {1} points? <br /> This action is irreversible.',
        reward_success_title: "Reward redeemed successfully!",
        reward_success_body:
            'The reward "{0}" was successfully redeemed for {1} points. <br />',
        client_points_title: "{0} has <strong>{1}</strong> points",
        client_coupons_title: "{0}'s Coupons",
        processing_coupons_title: "Coupons in processing",
        processing_coupons_desc:
            "These coupons are still being processed and the code will be generated soon.",
        automation_origin: "Source automation: {0}",
        active_coupons_title: "Active coupons",
        validity: "Validity:",
        until: "until:",
        not_registered: "Client not registered",
        send_sms_link: "Send Registration SMS",
        coupons_label: "Coupons:",
        processing_label: "({0} in processing)",
        view_coupons: "View coupons",
        points_label: "Points:",
        view_rewards: "View rewards",
        orders_label: "Orders:",
        birthdate_label: "Birthday:",
        email_label: "Email:",
        phone_label: "Phone:",
        view_profile: "View profile",
        coupon_not_yet_valid: "The coupon is not yet valid",
        coupon_expired: "The coupon has already expired",
        sms_success: "Link sent successfully!",
        sms_error:
            "Oops! An error occurred while sending the link. Please try again later.",
    },
    validateCoupon: {
        title: "Validate coupon",
        confirm_use_title: "Confirm coupon use",
        confirm_use_body:
            "Grant the benefit of {0}? <br /> This action is irreversible.",
        used_success_title: "Coupon used",
        used_success_body:
            "{0} coupon was used successfully. <br /> Coupon {1} is no longer valid",
        error_expired: "Coupon expired",
        error_not_yet_valid: "Coupon will be valid from",
        error_used: "Coupon already used",
        error_not_found: "Invalid coupon",
        valid_coupon: "Valid coupon",
        validate_button: "Validate coupon",
        use_button: "Use coupon",
    },
};
